import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Carousel, Container } from '@pella/sash-framework';
import { isValidArray } from '../../../utilities/validations';

import ResultsTile from '../../../../templates/plp/results/tile';
import SliderWithThumbnails from '../../../common/slider-with-thumbnails';
import HoverBannerSmall from '../../../third-party/hover/small-banner';

const ShopTheLook = ({ data, className }) => {
	const [activeLook, setActiveLook] = useState(0);
	const imageArray = data.looks.map((look) => look?.image?.[0]);

	const handleSlideChange = (index) => setActiveLook(index);

	return (
		<div className={`shopLook overflow-hidden py-6 md:py-8 xl:pb-6 xl:pt-0 ${className || ''}`}>
			<Container className='shopTheLook-container grid grid-cols-1 md:grid-cols-[50%_1fr] md:gap-x-14 xl:grid-rows-[1fr_auto_auto_1fr] xl:gap-x-[112px]'>
				<div className='shopTheLook-slider col-start-1 row-start-2 pb-6 md:row-start-1 xl:row-span-full'>
					<SliderWithThumbnails
						images={imageArray}
						onSlideChange={handleSlideChange}
					/>
				</div>

				<div className='shopTheLook-content col-start-1 row-start-1 mb-5 self-center md:col-start-2 md:mb-32 xl:row-start-2 xl:mb-0'>
					{data?.heading && <h2 className='shopTheLook-heading m-0'>{data.heading}</h2>}
					{data?.subheading && <p className='shopTheLook-subheading text-subtitle mt-2'>{data.subheading}</p>}
				</div>

				{isValidArray(data?.looks?.[activeLook]?.tiles) && (
					<div className='shopTheLook-tiles col-start-1 row-start-3 md:col-span-2 md:row-start-2 xl:col-span-1 xl:col-start-2 xl:row-start-3 xl:mt-12 max-md:[&>div]:h-auto md:[&>div]:flex-1 xl:[&>div]:h-auto'>
						<Carousel
							className='!block space-y-2 md:!flex md:space-y-0 xl:!block xl:space-x-0 xl:space-y-6'
							dotsClassName='hidden md:flex xl:hidden'
							slidesToShow={{ md: 2 }}
							slidePadding={16}
							showDots
						>
							{data.looks[activeLook].tiles.map((tile, index) => (
								<ResultsTile
									key={tile.backend_name}
									tile={tile}
									pdpURL={tile.static_url}
									variant='horizontal'
									className={`shopTheLook-tile-${index} max-w-[470px] max-xl:mx-auto`}
								/>
							))}

							<HoverBannerSmall className='h-full max-w-[470px] max-xl:mx-auto' />
						</Carousel>
					</div>
				)}
			</Container>
		</div>
	);
};

ShopTheLook.propTypes = {
	data: PropTypes.object.isRequired,
	className: PropTypes.string,
};

export default ShopTheLook;
